"use strict";

var jwtDecode = require('jwt-decode');
var get = require('lodash.get');
var format = require('date-fns/format');
var _require = require('./get-current-date'),
  getCurrentDate = _require.getCurrentDate;
var makeIsTokenExpired = function makeIsTokenExpired() {
  return function (_ref) {
    var token = _ref.token;
    var decoded = {};
    try {
      decoded = jwtDecode(token);
    } catch (err) {
      return true;
    }
    var expiry = get(decoded, 'exp');
    var now = format(getCurrentDate(), 'X'); // convert date to seconds

    if (!expiry) {
      return true;
    }
    var isExpired = now > expiry;
    return isExpired;
  };
};
module.exports = {
  makeIsTokenExpired: makeIsTokenExpired
};